var _polyline, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDownLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-down-left",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9 10 4 15 9 20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a4 4 0 0 1-4 4H4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDownLeft);
export default __webpack_public_path__ + "static/media/corner-down-left.c0e4e5bcbff6dece0b25379aa12f837f.svg";
export { ForwardRef as ReactComponent };